if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {
	// REMOVE REQUIRED CLASS FORM FOOTER FORM OFFERS CHECKBOX
	if (document.getElementById('yes-signup-formemail-signup')) {
		document.getElementById('yes-signup-formemail-signup').classList.remove('required');
	}

	// ANIMATE MAIN NAV ANCHORS
	let extraGap = 10;
	$('.privary-navigation__item > a, .inner li > a').click(function (e) {
		let currentHref = $(this).attr('href').replace('/', '');
		let headerHeight = $('.header').outerHeight() ? $('.header').outerHeight() : 0;
		let alertHeight = $('.header').css('top') ? parseInt($('.header').css('top')) : 0;

		if (currentHref.indexOf('#') > -1 && $(currentHref).length > 0) {
			e.preventDefault();
			$('html, body').animate({ scrollTop: $(currentHref).offset().top - headerHeight - alertHeight - extraGap }, 1000);
		}
	});

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e));

	$('.sym-slides').slick({
		accessibility: false,
	});

	$('.responsive_slides').slick({
		accessibility: false,
		slidesToShow: 2,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	$('.offers-slides').slick({
		slidesToShow: 3,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					dots: false,
				},
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});

	$(document).on('beforeShow.fb', function () {
		$('.offers-slides').slick('slickPause');
	});
	$(document).on('beforeClose.fb', function () {
		$('.offers-slides').slick('slickPlay');
	});

	$('[data-fancybox]').fancybox({
		infobar: false,
		loop: true,
	});

	// FANCYBOX SETTINGS
	$.fancybox.defaults.backFocus = false;
	$.fancybox.defaults.autoFocus = false;
	$.fancybox.defaults.touch = false;
	$.fancybox.defaults.smallBtn = true;
	$.fancybox.defaults.btnTpl.smallBtn = `<button class="fancybox-button fancybox-close-small" title="{{CLOSE}}" type="button" data-fancybox-close><svg fill="none" stroke="currentColor" stroke-width="1" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><line x1="1" y1="1" x2="17" y2="17" /><line x1="17" y1="1" x2="1" y2="17" /></svg></button>`;
	$.fancybox.defaults.btnTpl.arrowLeft = `<button class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}" type="button" data-fancybox-prev><span>Prev</span><?xml version="1.0" encoding="UTF-8"?><svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 14"><defs><style>.cls-1{fill:none;stroke:#474c21;stroke-miterlimit:10;stroke-width:2.5px;}</style></defs><path class="cls-1" d="M27.62,14c0-3.87,3.31-7,7.38-7m0,0c-4.08,0-7.38-3.13-7.38-7m7.38,7H0"/></svg></button>`;
	$.fancybox.defaults.btnTpl.arrowRight = `<button class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}" type="button" data-fancybox-next><span>Next</span><?xml version="1.0" encoding="UTF-8"?><svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 14"><defs><style>.cls-1{fill:none;stroke:#474c21;stroke-miterlimit:10;stroke-width:2.5px;}</style></defs><path class="cls-1" d="M27.62,14c0-3.87,3.31-7,7.38-7m0,0c-4.08,0-7.38-3.13-7.38-7m7.38,7H0"/></svg></button>`;

	$('[data-slick_prev]').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		$curSlider.slick('slickPrev');
	});

	$('[data-slick_next]').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		$curSlider.slick('slickNext');
	});

	$('[data-slick-goto]').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		const target = $(this).data('slick-goto') ? parseInt($(this).data('slick-goto')) : 0;

		$curSlider.slick('slickGoTo', target);
		$(this).siblings('[data-slick-goto]').removeClass('active');
		$(this).addClass('active');
	});

	// SWIPER
	const swiperClass = '.swiper';
	const swiperOps = {
		createElements: true,
		loop: true,
	};

	document.querySelectorAll(swiperClass).forEach((slider) => {
		const sliderOps = slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {};

		const swiper = new Swiper(swiperClass, Object.assign({}, swiperOps, sliderOps));
	});
})();
